module.exports = __webpack_public_path__ + "static/img/fish7.7f2d39a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish7.png
// module id = RzZi
// module chunks = 0